import Vue from 'vue';

export default {
  initializeApp(state, payload) {
    Vue.set(state, 'visitorId', payload.visitorId);
    Vue.set(state, 'lang', payload.lang);
  },
  loadCmsData(state) {
    Vue.set(state, 'cmsData', null);
    Vue.set(state, 'dataLoadError', null);
    Vue.set(state, 'showLoadindicator', true);
  },
  loadCmsDataSuccess(state, payload) {
    Vue.set(state, 'cmsData', payload);
    Vue.set(state, 'showLoadindicator', false);
  },
  loadCmsDataFailed(state, payload) {
    Vue.set(state, 'dataLoadError', payload);
    Vue.set(state, 'showLoadindicator', false);
  },
  updateCurrentLevelIndex(state, payload) {
    if (typeof payload == 'undefined') {
      payload = state.currentLevelIndex + 1;
    }
    Vue.set(state, 'currentLevelIndex', payload);
    Vue.set(state, 'currentQuizOptions', []);
    Vue.set(state, 'isLevelEnd', false);

    if (!state.levelStatistics.find(item => item.id === payload)) {
      let levelStatistics = [ ...state.levelStatistics ];
      levelStatistics.push({ levelId: payload, totalCorrectAnswers: 0, correctAnswered: 0, wrongAnswered: 0 })
      Vue.set(state, 'levelStatistics', levelStatistics);
    }
  },
  updateTotalCorrectAnswers(state) {
    let levelStatistics = [ ...state.levelStatistics ];
    levelStatistics.forEach(item => {
      if (item.levelId === state.currentLevelIndex) {
        item.totalCorrectAnswers++;
      }});
    Vue.set(state, 'levelStatistics', levelStatistics);
  },
  updateCorrectAswered(state) {
    let levelStatistics = [ ...state.levelStatistics ];
    levelStatistics.forEach(item => {
      if (item.levelId === state.currentLevelIndex) {
        item.correctAnswered++;
        if (item.correctAnswered >= item.totalCorrectAnswers)
          Vue.set(state, 'isLevelEnd', true);
      }});
    Vue.set(state, 'levelStatistics', levelStatistics);
  },
  updateWrongAswered(state) {
    let levelStatistics = [ ...state.levelStatistics ];
    levelStatistics.forEach(item => {
      if (item.levelId === state.currentLevelIndex) {
        item.wrongAnswered++;
      }});
    Vue.set(state, 'levelStatistics', levelStatistics);
  },
  updateGlobalPlayState(state, payload) {
    Vue.set(state, 'playAudio', payload);
  },
  updateScreenState(state, payload) {
    Vue.set(state, 'screenState', payload);
  },
  updateStartTimestamp(state, payload) {
    Vue.set(state, 'stationStartTimestamp', payload);
  },
  updateEndTimestamp(state, payload) {
    Vue.set(state, 'stationEndTimestamp', payload);
  },
  updateClickCounter(state) {
    Vue.set(state, 'clickCount', state.clickCount + 1);
  },
  sendStatistics(state) {
    Vue.set(state, 'showLoadindicator', true);
    Vue.set(state, 'lastHttpAction', 'sendStatistics');
  },
  sendStatisticsSuccess(state, payload) {
    Vue.set(state, 'sendStatisticsSuccess', payload);
    Vue.set(state, 'showLoadindicator', false);
    Vue.set(state, 'lastHttpAction', null);
    window.postMessage('end');
  },
  sendStatisticsFailed(state, payload) {
    Vue.set(state, 'dataLoadError', payload);
    Vue.set(state, 'showLoadindicator', false);
  },
};
